<template>
  <el-dialog
    :title="$t('integralWithdrawal.audit.title')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('integralWithdrawal.audit.integralName')">
            <el-input v-model="form.integralName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('integralWithdrawal.audit.bankName')">
            <el-input v-model="form.bankName" disabled />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('integralWithdrawal.audit.bankNumName')">
            <el-input v-model="form.bankNumName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('integralWithdrawal.audit.bankNum')">
            <el-input v-model="form.bankNum" disabled />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('integralWithdrawal.audit.applyUserName')">
            <el-input v-model="form.applyUserName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('integralWithdrawal.audit.applyUserTel')">
            <el-input v-model="form.applyUserTel" disabled />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('integralWithdrawal.audit.amount')">
        <el-input v-model="form.applyAmount" disabled />
      </el-form-item>

      <el-form-item :label="$t('integralWithdrawal.audit.remark')">
        <el-input v-model="form.remark" disabled />
      </el-form-item>

      <el-form-item :label="$t('integralWithdrawal.audit.state')" required>
        <el-select 
          v-model="form.state" 
          style="width:100%"
          :placeholder="$t('integralWithdrawal.audit.selectState')"
        >
          <el-option
            v-for="item in stateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item 
        :label="$t('integralWithdrawal.audit.stateMsg')" 
        required
        v-if="form.state === 'F'"
      >
        <el-input
          v-model="form.stateMsg"
          type="textarea"
          :placeholder="$t('integralWithdrawal.audit.stateMsgPlaceholder')"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button 
        type="primary" 
        @click="handleSubmit"
        :loading="loading"
      >
        {{ $t('common.submit') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { auditIntegralWithdrawal } from '@/api/admin/integralWithdrawal/integralWithdrawalApi'

export default {
  name: 'AuditIntegralWithdrawal',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        iwId: '',
        integralId: '',
        integralName: '',
        shopId: '',
        amount: '',
        applyAmount: '',
        applyUserName: '',
        applyUserTel: '',
        remark: '',
        state: '',
        stateMsg: '',
        bankNum: '',
        bankNumName: '',
        bankName: ''
      },
      stateOptions: [
        { value: 'C', label: this.$t('integralWithdrawal.audit.stateOptions.approved') },
        { value: 'F', label: this.$t('integralWithdrawal.audit.stateOptions.rejected') }
      ]
    }
  },
  methods: {
    open(data) {
      this.form = {
        ...this.form,
        ...data,
        applyAmount: data.amount,
        state: '',
        stateMsg: ''
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.form = {
        iwId: '',
        integralId: '',
        integralName: '',
        shopId: '',
        amount: '',
        applyAmount: '',
        applyUserName: '',
        applyUserTel: '',
        remark: '',
        state: '',
        stateMsg: '',
        bankNum: '',
        bankNumName: '',
        bankName: ''
      }
    },
    async handleSubmit() {
      if (!this.form.state) {
        this.$message.warning(this.$t('integralWithdrawal.audit.stateRequired'))
        return
      }

      if (this.form.state === 'F' && !this.form.stateMsg) {
        this.$message.warning(this.$t('integralWithdrawal.audit.stateMsgRequired'))
        return
      }

      this.loading = true
      try {
        await auditIntegralWithdrawal(this.form)
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>